// extracted by mini-css-extract-plugin
module.exports = {"player":"Player-module_player_2SMHq","fullScreen":"Player-module_fullScreen_3tdOR","halfScreen":"Player-module_halfScreen_2JPxd"};